import React from 'react'
import Layout from './app/Layout'

export default class App extends React.Component {
	render() {
		return (<Layout />);
	}
}
